// JavaScript Document

/***** モーダル表示 アクセス処理 *****/
$(function () {
  var webStorage = function () {
    if (sessionStorage.getItem('access')) {
      /*
        2回目以降アクセス時の処理
      */
      $(".modal_access").addClass('is-active');
    } else {
      /*
        初回アクセス時の処理
      */
      sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
      $(".modal_access-animation").addClass('is-active');

    $('.modal_access-animation, .closeBtn').click(function() {
        $(this).fadeOut().removeClass('is-active');
        $(".modal_access").addClass('is-active');
    })

    }
  }
  webStorage();
});